import React, { useState } from 'react';
import { TextField, Button, Box, Typography, CircularProgress, Grid, ButtonGroup, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { PartnerDetailsTable } from './components/partnerDetails';
import { useNavigate } from 'react-router-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DialogComponent from './components/dialogComponent';

function ProvisionScreen() {
    const [companyId, setcompanyId] = useState('');
    const [partnerId, setpartnerId] = useState('');
    const [ssoToken, setSsoToken] = useState(localStorage.getItem('ssoToken'));
    const [domain, setDomain] = useState('');
    const [instanceId, setInstanceId] = useState('');
    const [result, setResult] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [partnerIdError, setpartnerIdError] = useState(false);
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(-1);
    const [version] = useState('v4.0');
    const options = ['NA Entitlement', 'EU Entitlement', 'AU Entitlement'];
    const apiUrl = process.env.REACT_APP_FLASK_API_URL_PROD || '';
    const [results, setResults] = useState({
        open: false,
        title: '',
        description: '',
        children: null,
    });
    const useStyles = makeStyles((theme) => ({
        container: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
        },
        formBox: {
            padding: theme.spacing(4),
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#f4f7fd',
            marginTop: theme.spacing(2),
            width: '90%',
        },
        heading: {
            marginBottom: theme.spacing(1),
        },
        optInForm: {

        }
    }));
    const classes = useStyles();

    const handleLogout = () => {
        fetch(apiUrl + '/api/provision/logout', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'sso-token': sessionStorage.getItem('ssoToken'),
            },
        })
        .then(() => {
            console.log("Successfully logged out");
        })
        .catch((error) => {
            console.error('Error logging out:', error);
        })
        .finally(() => {
            sessionStorage.removeItem('isAuthenticated');
            sessionStorage.removeItem('ssoToken')
            navigate('/login');
        });
    };

    const handleSubmit = (event) => {
        if (event && event.preventDefault) {
            event.preventDefault();
        }

        if (!partnerId && !companyId && !instanceId) {
            setError("At least one of partnerId, companyId, or instanceId must have a value.");
            setpartnerIdError(true);
            setLoading(false);
            return;
        }

        setError(null);
        setLoading(true);
        console.log("Calling /api/provision/getPartner");
            try {
                fetch(apiUrl + '/api/provision/getPartner', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                    },
                    body: JSON.stringify({ partnerId: partnerId, companyId: companyId, instanceId: instanceId }, null, 2),
                })
                .then((response) => response.json())
                .then((data) => {
                    //console.log("This is the data:", data);
                    setResult(data);
                    setpartnerId(data[0]['partnerId'])
                    setDomain(data[0]['metadata']['domain'])
                    //console.log("Domain in data: ", data[0]['metadata']['domain'])
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error in getPartner fetch: ', error);
                    setLoading(false);
                });
        } catch (err) {
            console.log("Error calling getPartner", err);
        }

    };

    const handleFixType = () => {
        console.log("Calling /api/provision/fixType");
        try {
            setLoading(true);
            fetch(apiUrl + '/api/provision/fixType', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({ partnerId: partnerId }, null, 2),
            })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                setResults({
                    open: true,
                    title: 'Result:',
                    description: <pre>{JSON.stringify(data, null, 2)}</pre>,
                    children: '',
                });
            })
            .catch((error) => {
                console.error('Error in fixType fetch: ', error);
                setLoading(false);
            });
        } catch (err) {
            console.log("Error calling fixType", err);
        }
    };

    const handleAddEntitlement = () => {
        console.info(`You clicked ${options[selectedIndex]}`);
        console.log("Calling /api/provision/addEntitlement");
        const selectedRegion = options[selectedIndex].substring(0, 2);
        console.log("Selected Region for addEntitlement: ", selectedRegion)
        let subdomain = '';

        if ( selectedRegion === 'NA') {
            subdomain = 'na';
        } else if (selectedRegion === 'EU') {
            subdomain = 'eu';
        } else if (selectedRegion === 'AU') {
            subdomain = 'au';
        } else {
            subdomain = 'na';
        }

        try {
            setLoading(true);
            fetch(apiUrl + '/api/provision/addEntitlement', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({ partnerId: partnerId, subdomain: subdomain, ssoToken: ssoToken}, null, 2),
            })
            .then((response) => response.json())
            .then((data) => {
                //setResult(data);
                console.log("Entitlement Data: ", data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error in addEntitlement fetch: ', error);
                setLoading(false);
            });
        } catch (err) {
            console.log("Error calling addEntitlement", err);
        }
    };

    const handleEntitleCheck = () => {
        console.log("Calling /api/provision/checkEntitlement");

        const extractedDomain = domain.substring(0, domain.indexOf('.')); // Extracting the domain before the first dot
        console.log("Extracted Domain: ", extractedDomain);
        let subdomain = '';

        if ( extractedDomain === 'na') {
            subdomain = 'na';
        } else if (extractedDomain === 'eu') {
            subdomain = 'eu';
        } else if (extractedDomain === 'au') {
            subdomain = 'au';
        } else {
            subdomain = 'na';
        }

        try {
            setLoading(true);
            fetch(apiUrl + '/api/provision/checkEntitlement', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({ partnerId: partnerId, subdomain: subdomain, ssoToken: ssoToken }, null, 2),
            })
            .then((response) => response.json())
            .then((data) => {
                //setResult(data);
                console.log("Entitlement Data: ", data);
                setLoading(false);
                setResults({
                    open: true,
                    title: 'Entitlement Details:',
                    description: <pre>{JSON.stringify(data, null, 2)}</pre>,
                    children: '',
                });
            })
            .catch((error) => {
                console.error('Error in checkEntitlement fetch: ', error);
                setLoading(false);
            });
        } catch (err) {
            console.log("Error calling checkEntitlement", err);
        }
    };


    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    return (
        <>
        <div className={classes.container}>
        <Box className={classes.formBox} m={2}>
            <Grid container spacing={1} rowSpacing={1} columnSpacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h5" className={classes.heading}>CW Sidekick for PSA - Provisioning Tool</Typography>
                    <form className={classes.optInForm} onSubmit={handleSubmit}>
                        <Grid item xs={12}>
                            <TextField
                                label="Partner Id"
                                variant="outlined"
                                value={partnerId}
                                onChange={(e) => setpartnerId(e.target.value)}
                                fullWidth={true}
                                margin="normal"
                                error={partnerIdError}
                                sx={{ maxWidth: '300px', marginRight: 2 }} />
                            <TextField
                                label="Company Id"
                                variant="outlined"
                                value={companyId}
                                onChange={(e) => setcompanyId(e.target.value)}
                                fullWidth={true}
                                margin="normal"
                                sx={{ maxWidth: '200px', marginRight: 2}} />
                            <TextField
                                label="Instance Id"
                                variant="outlined"
                                value={instanceId}
                                onChange={(e) => setInstanceId(e.target.value)}
                                fullWidth={true}
                                margin="normal"
                                sx={{ maxWidth: '300px' }} />
                        </Grid>
                        <Button variant="contained" color="primary" type="submit">Search</Button>
                    </form>
                    {result &&
                        <>
                        <Button size="small" variant="outlined" color="primary" style={{ marginTop: '30px' }} onClick={handleFixType}>Fix Instance Type</Button>
                        {/*<ButtonGroup variant="outlined" color="primary" ref={anchorRef} aria-label="split button" style={{ marginTop: '30px' }}>
                            <Button size="small" onClick={handleAddEntitlement}>{selectedIndex === -1 ? 'Add Entitlement' : options[selectedIndex]}</Button>
                            <Button
                                size="small"
                                aria-controls={open ? 'split-button-menu' : undefined}
                                aria-expanded={open ? 'true' : undefined}
                                aria-label="select merge strategy"
                                aria-haspopup="menu"
                                onClick={handleToggle}
                            >
                                <ArrowDropDownIcon />
                            </Button>
                        </ButtonGroup>
                        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                            {({ TransitionProps, placement }) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{
                                        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                                        zIndex: 999999
                                    }}
                                >
                                    <Paper>
                                        <ClickAwayListener onClickAway={handleClose}>
                                            <MenuList id="split-button-menu">
                                                {options.map((option, index) => (
                                                    <MenuItem
                                                        key={option}
                                                        selected={index === selectedIndex}
                                                        onClick={(event) => handleMenuItemClick(event, index)}
                                                    >
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                        <Button size="small" variant="outlined" color="primary" style={{ marginLeft: '20px' }} onClick={handleEntitleCheck}>Check Entitlement</Button>
                        */}
                        </>
                    }
                    {loading && <CircularProgress sx={{marginTop: 5, position: 'absolute', top: '15%', left: '50%', transform: 'translate(-50%, -50%)' }}/>}
                    {error && <div>{error}</div>}
                    {result && <PartnerDetailsTable result={result} handleSubmit={handleSubmit}/>}
                    {results && (
                        <DialogComponent
                            open={results.open}
                            handleClose={() => setResults({ ...results, open: false })}
                            title={results.title}
                            description={results.description}
                        >
                            {results.children}
                        </DialogComponent>
                    )}
                </Grid>
            </Grid>
            <div style={{ textAlign: 'right', marginTop: 10 }}>@2024 SideKick ({version}) <Button size="small" variant="outlined" color="primary" onClick={handleLogout}>Logout</Button></div>
        </Box>
        </div>
        </>
    );
}
export default ProvisionScreen;